import { Routes, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { TdsWizardService } from './tds-wizard.service';
import { ProgressBarService } from '../progress-bar.service';
import { SnackBarService } from '../snack-bar.service';
import { first, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const tdsRoutes: Routes = [
  {
    path: 'cardata-container',
    redirectTo: 'cardata-container/ucb2b-cardata-wizard',
    pathMatch: 'full',
  },
  {
    path: 'cardata-container/ucb2b-cardata-wizard',
    canActivate: [
      (): Observable<boolean | UrlTree> => {
        const progressBar = inject(ProgressBarService);
        const snackBar = inject(SnackBarService);
        const router = inject(Router);

        progressBar.start();
        return inject(TdsWizardService).tdsIsReady().pipe(
          // skip the initial false from BehaviorSubject — wait for a real result
          first(ready => ready !== null),
          tap(() => progressBar.stop()),
          map(ready => {
            if (ready) {
              return true;
            }
            snackBar.showErrorWithAction('TDS.NOT_AVAILABLE');
            return router.parseUrl('/');
          }),
        );
      },
    ],
    loadComponent: () =>
      import('./cardata-proxy/cardata-proxy.component').then(
        (m) => m.CarDataProxyComponent,
      ),
  },
];
